module.exports = "/static/assets/d9ba5ee866df39f60291d55f77c4e331.png";